import { FC } from 'react';

export type NavItem = {
  label: string;
  href: string;
  overlay?: string;
};

interface NavLinksProps {
  items: NavItem[];
  isActive: (path: string) => boolean;
  onNavigate: (href: string, overlay?: string) => void;
}

const NavLinks: FC<NavLinksProps> = ({ items, isActive, onNavigate }) => {
  return (
    <nav className="flex flex-wrap items-center gap-4 text-sm leading-none md:gap-5">
      {items.map((item) => (
        <div key={item.label} className="flex items-center gap-3">
          <span
            className={[
              'inline-block h-2 w-2 rounded-full align-middle transition-colors duration-150',
              isActive(item.overlay || item.href)
                ? 'bg-zinc-900 dark:bg-zinc-100'
                : 'border border-zinc-500 dark:border-zinc-400',
            ].join(' ')}
          />
          <a
            href={item.href}
            onClick={(event) => {
              event.preventDefault();
              onNavigate(item.href, item.overlay);
            }}
            className={[
              'transition-colors duration-150',
              isActive(item.overlay || item.href)
                ? 'font-medium text-zinc-900 dark:text-zinc-100'
                : 'text-zinc-700 hover:text-black dark:text-zinc-300 dark:hover:text-white',
            ].join(' ')}
          >
            {item.label}
          </a>
        </div>
      ))}
    </nav>
  );
};

export default NavLinks;
